window.addEventListener('load', function() {
    let dotEls = document.querySelectorAll('.jsEllipsis');
    if (dotEls.length) {
        let windowW = window.innerWidth;
        dotEls.forEach(dotEl => {
            dotEl.style.webkitLineClamp = dotEl.dataset.line;
            if (windowW < 1200 && dotEl.dataset.lineMobile) {
                dotEl.style.webkitLineClamp = dotEl.dataset.lineMobile;
            }
            dotEl.classList.add('he-ellipsis');
        });
    }
});